import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import AdoptableCountdown from '@wix/da-ds/pkg/Time/AdoptableCountdown';
import s from './Countdown.scss';
const Countdown = ({ offerEndTime, onEnd, hasEnded, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['label']
    }, t(hasEnded ? 'sidebar.exclusives.countdown.offerEnded' : 'sidebar.exclusives.countdown.offerEnd')), /*#__PURE__*/ React.createElement("div", {
        className: s['value']
    }, /*#__PURE__*/ React.createElement(AdoptableCountdown, {
        offerEndTime: offerEndTime,
        endedClassName: s['offer-ended'],
        endedMessage: `00:00:00`,
        onEnd: onEnd
    })));
};
Countdown.displayName = 'Countdown';
export default Countdown;
